// src/services/categoryService.js
import apiClient from '../../../api/client';

/**
 * Service for managing categories
 */
const categoryService = {
  /**
   * Get all categories
   * @returns {Promise<Array>} - Array of categories
   */
  getAll: async () => {
    try {
      // Use the correct endpoint from pos.route.js
      const response = await apiClient.get('/api/v1/pos/pos-categories');
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  /**
   * Get a category by ID
   * @param {number} id - Category ID
   * @returns {Promise<Object>} - Category object
   */
  getById: async (id) => {
    try {
      const response = await apiClient.get(`/api/v1/pos/pos-categories/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching category ${id}:`, error);
      throw error;
    }
  },

  /**
   * Create a new category
   * @param {Object} category - Category data
   * @returns {Promise<Object>} - Created category
   */
  create: async (category) => {
    try {
      // Use the correct endpoint from pos.route.js
      const response = await apiClient.post('/api/v1/pos/pos-categories', category);
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },

  /**
   * Update a category
   * @param {number} id - Category ID
   * @param {Object} category - Updated category data
   * @returns {Promise<Object>} - Updated category
   */
  update: async (id, category) => {
    try {
      // Use the correct endpoint from pos.route.js
      const response = await apiClient.put(`/api/v1/pos/pos-categories/${id}`, category);
      return response.data;
    } catch (error) {
      console.error(`Error updating category ${id}:`, error);
      throw error;
    }
  },

  /**
   * Delete a category
   * @param {number} id - Category ID
   * @returns {Promise<Object>} - Response data
   */
  delete: async (id) => {
    try {
      // Use the correct endpoint from pos.route.js
      const response = await apiClient.delete(`/api/v1/pos/pos-categories/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting category ${id}:`, error);
      throw error;
    }
  },

  /**
   * Toggle category status (active/inactive)
   * @param {number} id - Category ID
   * @param {boolean} isActive - New status
   * @returns {Promise<Object>} - Updated category
   */
  toggleStatus: async (id, isActive) => {
    try {
      const response = await apiClient.patch(`/api/v1/pos/pos-categories/${id}/status`, { isActive });
      return response.data;
    } catch (error) {
      console.error(`Error updating category status ${id}:`, error);
      throw error;
    }
  }
};

export default categoryService;